export default __webpack_public_path__ + "static/media/japan.d55efba5.webp";